import { CopyOutlined } from '@ant-design/icons';
import { getDownloadURL } from 'library/firebase/fb.utils';
import { copyToClipBoard } from 'library/helpers/utility';
import WithHyperLink from 'library/hoc/withHyperLink';
import { useManagePermittedRoles } from 'library/hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'zComponents/atoms';
import { Card, Col, Flex, Row, Typography } from 'zui/Antd';
import AccessPeopleTable from '../AccessPeopleTable';
import GrantPermissionModal from '../GrantPermissionModal';
import RemoteActionsButton from '../RemoteActionsButton';

const { Text, Title } = Typography;

const AccessSummaryCard = ({ data }) => {
	// const MAP_HEIGHT = 460;
	// const MAP_WIDTH = 800;
	const [, setMapUrl] = useState('');
	const { data: devicesData } = useSelector((state) => state.Devices);
	const { data: floorsData } = useSelector((state) => state.Floors);
	const [selectedLock, setSelectedLock] = useState({});
	const [currentFloor, setCurrentFloor] = useState({});
	const [grantPermissionModalVisible, setGrantPermissionModalVisible] = useState(false);
	const [, setLocksByFloor] = useState([]);
	const {
		remoteConfig: { constants }
	} = useSelector((state) => state.FbRemoteConfig);
	const [remoteUnlockVisible, setRemoteUnlockVisible] = useState(false);

	// HOC
	const LockNameWithLink = WithHyperLink(() => (
		<Title
			level={4}
			style={{
				margin: 0
			}}
		>
			{selectedLock.name}
		</Title>
	));

	useEffect(() => {
		setSelectedLock(data);
	}, [data]);

	useEffect(() => {
		if (selectedLock?.location?.length > 0) {
			const lockLocation = selectedLock.location[0];
			const locations = [];
			const floor = floorsData.find((floor) => floor.floorID === lockLocation.floorID);
			setCurrentFloor(floor);
			getDownloadURL(floor.url).then((url) => setMapUrl(url));

			devicesData.forEach((device) => {
				const location = device?.location?.map((location) => {
					if (location.floorID === floor.floorID) return location;
					return null;
				});
				const cleanLocation = location.filter((item) => item);
				if (cleanLocation.length > 0)
					locations.push({
						...device,
						x: cleanLocation[0].xAxis,
						y: cleanLocation[0].yAxis,
						selectedDevice: device.uID === selectedLock.uID
					});
			});
			setLocksByFloor(locations.filter((item) => item?.defaultCategoryID === constants.SMART_LOCKS));
		}

		return () => {
			setMapUrl('');
			setCurrentFloor({});
			setLocksByFloor([]);
		};
	}, [floorsData, selectedLock, devicesData, currentFloor, constants]);

	const permittedLocationsObjects =
		selectedLock?.location?.length > 0
			? selectedLock.location.map((item) => floorsData.find((floor) => floor.floorID === item.floorID))
			: [];

	const isPermittedRemoteUnlock = useManagePermittedRoles('aCRemoteUnlock', {
		orgID: [data.orgID],
		siteID: permittedLocationsObjects.map((item) => item.siteID).filter((item) => item),
		floorID: permittedLocationsObjects.map((item) => item.floorID).filter((item) => item)
	});

	const isPermittedGrantPermission = useManagePermittedRoles('aCPermissionManagement', {
		orgID: [data.orgID],
		siteID: permittedLocationsObjects.map((item) => item.siteID).filter((item) => item),
		floorID: permittedLocationsObjects.map((item) => item.floorID).filter((item) => item)
	});

	return !data.uID ? (
		<Loader />
	) : (
		<Card>
			<Row>
				<Col span={12}>
					<Flex vertical>
						<LockNameWithLink
							dataID={selectedLock.uID}
							type='device'
							suppData={{
								categoryID: selectedLock.categoryID
							}}
						/>
						<Text className='uidContainer' onClick={() => copyToClipBoard(selectedLock.uID)}>
							<span className='IDLabel'>UID: </span>
							{selectedLock.uID} {''}
							<CopyOutlined />
						</Text>
					</Flex>
				</Col>
				<Col span={12}>
					<Row gutter={[10, 10]} justify={'end'}>
						<Col>
							{isPermittedGrantPermission ? (
								<GrantPermissionModal
									visible={grantPermissionModalVisible}
									setVisible={setGrantPermissionModalVisible}
									data={{
										deviceID: selectedLock.uID,
										deviceName: selectedLock.name
									}}
								/>
							) : null}
						</Col>
						<Col>
							{isPermittedRemoteUnlock && (
								<RemoteActionsButton
									data={{
										deviceID: selectedLock.uID,
										name: selectedLock.name
									}}
									visible={remoteUnlockVisible}
									setVisible={setRemoteUnlockVisible}
								/>
							)}
						</Col>
					</Row>
				</Col>
				<Col>
					{/* {mapUrl !== '' ? (
					<LeafletMap
						markerList={locksByFloor}
						mapHeight={MAP_HEIGHT}
						mapWidth={MAP_WIDTH}
						scrollWheelZoom={true}
						url={mapUrl}
					/>
				) : null} */}
				</Col>
				<Col
					style={{
						marginTop: 20
					}}
				>
					<AccessPeopleTable lock={selectedLock} />
				</Col>
			</Row>
		</Card>
	);
};

export default AccessSummaryCard;
